export const LINK_EXISTING_WALLET = 'WALLET_LINK/EXISTING'
export const LINK_NEW_WALLET = 'WALLET_LINK/NEW'
